import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import type { IModelText } from './IModelText';
import { useRefName } from './useRefName';

/**
 * Підписи моделі даних модуля (прототип v4 mdSel): назва сутності — однина (як у прототипі), тип поля — «текст», «список», «посилання →
 * Справи», варіанти — підписи значень через кому, системні поля — «системне поле».
 */
export function useModelText(ws: string, moduleKey: string): IModelText {
  const { t } = useTranslation();
  const strings = useModuleStrings(moduleKey);
  const refName = useRefName(ws);
  return useMemo(() => ({
    name: (rt) => strings.entity(rt.key, 'singular', rt.singular ?? null) || strings.entity(rt.key, 'name', rt.name),
    description: (rt) => strings.entity(rt.key, 'description', rt.description ?? null),
    field: (rt, f) => strings.field(rt.key, f.key, f.label),
    type: (f) => `${t(`modDesign.types.${f.type}`, { defaultValue: f.type })}${f.ref ? ` → ${refName(f.ref)}` : ''}`,
    typeName: (f) => t(`modDesign.types.${f.type}`, { defaultValue: f.type }),
    options: (rt, f) => (f.options ?? []).map((o) => strings.option(rt.key, f.key, o.value, o.label)).join(', ') || (f.system ? t('modDesign.model.system') : ''),
    status: (rt, value) => strings.status(rt.key, value, rt.statuses.list.find((s) => s.value === value)?.label),
  }), [t, strings, refName]);
}
